import { useMutation } from '@tanstack/react-query'
import { useTypedApiClient } from 'hooks/useTypedApiClient'
import {
  type SweepstakeWinnerRequest,
  type FullSweepstakeWinner,
} from 'types/api'

export const usePutSweepstakeWinner = ({
  onError,
  onSuccess,
}: {
  onError: () => void | Promise<void>
  onSuccess: (data: FullSweepstakeWinner) => void | Promise<void>
}) => {
  const putClient = useTypedApiClient({
    path: '/admin/sweepstake-winners/{id}',
    method: 'put',
  })
  return useMutation({
    mutationFn: async ({ req }: { req: SweepstakeWinnerRequest }) => {
      const { data } = await putClient({ ...req, id: Number(req.id) })
      return data
    },
    onSuccess: async (data) => {
      if (onSuccess) {
        await onSuccess(data)
      }
    },
    onError,
  })
}
